import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { IUserGroup } from '../../../redux/userGroups/userGroupsSlice';
import RowActions from './RowActions';
import AddRemoveMembersCell from './AddRemoveMembersCell';

interface IRenderCellParams {
  row: IUserGroup;
}

export interface IColumn {
  field: string;
  headerName: string;
  hide?: boolean;
  width?: number;
  disableColumnMenu?: boolean;
  sortable?: boolean;
  flex?: number;
  renderCell?: (_params: IRenderCellParams) => React.ReactNode;
  renderHeader?: (_params: IRenderCellParams) => React.ReactNode;
}

const getColumns = (): IColumn[] => {
  const { t } = useTranslation();
  return [
    { field: 'id', headerName: 'ID', hide: true },
    {
      field: 'name',
      headerName: t('userGroups.table.groupName'),
      width: 500,
      disableColumnMenu: true,
      sortable: false,
      flex: 5.5,
      renderHeader: () => (
        <Typography variant="meta" color="primary.main">
          {t('userGroups.table.groupName')}
        </Typography>
      ),
      renderCell: (params: IRenderCellParams) => (
        <Typography variant="bodyRegular" color="primary">
          {params.row.name}
        </Typography>
      ),
    },
    {
      field: 'noOfMembers',
      headerName: t('userGroups.table.noOfMembers'),
      width: 400,
      disableColumnMenu: true,
      sortable: false,
      flex: 5,
      renderHeader: () => (
        <Typography variant="meta" color="primary.main">
          {t('userGroups.table.noOfMembers')}
        </Typography>
      ),
      renderCell: (params: IRenderCellParams) => <AddRemoveMembersCell row={params.row} />,
    },
    {
      field: 'action',
      width: 150,
      disableColumnMenu: true,
      sortable: false,
      flex: 1.5,
      renderCell: (params: IRenderCellParams) => <RowActions row={params.row} />,
      headerName: '',
    },
  ];
};

export default getColumns;
